import React, { useState, useEffect } from 'react';
import {  Col, Modal, Row, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import '../../../../styles/RegDashboard.css';
import { HHIEButton } from '../../../utility/HHIEButton';

export function MultiAccountModal(props) {
    const [accounts, setAccounts] = useState(null);
    const [tempAccounts, setTempAccounts] = useState([]);
    const [selectAccounts, setSelectAccounts] = useState(false);
    const [tempAlertAccounts, setTempAlertAccounts] = useState([])
    const [alertHHIE, setAlertHHIE] = useState(false);

    useEffect(() => {
        setAccounts(props.accounts);
        setSelectAccounts(props.selectAccounts);
    }, [props]);

    const changeTempAccountsList = (acctId, checked) => {
        let accts = tempAccounts;
        if (checked) {
            if (accts.indexOf(acctId, 1) === -1) {
                accts.push(acctId);
                setTempAccounts(accts);
            }
            setTempAccounts(accts);
        }
        else {
            accts.splice(accts.indexOf(acctId, 1))
            setTempAccounts(accts)
        }
        return accts;
    }

    const changeTempAlertAccountsList = (acctId, checked) => {
        let accts = tempAlertAccounts;
        if (checked) {
            if (accts.indexOf(acctId, 1) === -1) {
                accts.push(acctId);
            }
        }
        else {
            accts.splice(accts.indexOf(acctId, 1))
        }
        return accts;
    }

    const submitAccountsList = () => {
        if (tempAccounts.length > 0) {
            var accts = accounts.filter((account) => {
                for (var i = 0; i < tempAccounts.length; i++) {
                    if (account.id === tempAccounts[i]) {
                        return true;
                    }
                }
                return false;
            });
            props.setAccounts(accts);
            setTempAccounts([]);
            props.setSelectAccounts(false);
        }
        else {
            alert("At least one account must be selected");
        }
    }

    const submitAlertAccountsList = () => {
        if (tempAlertAccounts.length > 0) {
            var accts = accounts.filter((account) => {
                for (var i = 0; i < tempAlertAccounts.length; i++) {
                    if (account.id === tempAlertAccounts[i]) {
                        return true;
                    }
                }
                return false;
            });

            var newAcctList = accounts.filter((account) => {
                for (var i = 0; i < tempAlertAccounts.length; i++) {
                    if (account.id === tempAlertAccounts[i]) {
                        return false;
                    }
                }
                return true;
            })
            setAccounts(newAcctList);

            const formData = new FormData();
            formData.append("user",props.user.sfid)
            for (var i = 0; i <= (accts.length - 1); i++) {
                formData.append("account"+i,accts[i].id)
            }

            const requestOptions = {
                method: "POST",
                body: formData
            }
            fetch('/api/POCUser/POCAlertWrongAccounts', requestOptions)
                .then((response) => {
                    response.json()
                        .then((json) => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            else alert(json.message);
                        })
                        .catch((error) => {
                            console.log("wrongAccounts Text Error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("wrongAccounts Response Error: " + error);
                });

            setTempAlertAccounts([]);
            setAlertHHIE(false);
        }
        else {
            alert("No accounts were selected");
        }
    }

    return (
        <>
        <Modal
            show={selectAccounts}
            size="md"
            centered
            backdrop="static"
            onHide={() => { setSelectAccounts(false) }}
        >
            <Modal.Header className="d-flex justify-content-center">
                <Modal.Title className="d-flex justify-content-center">
                    Select any Accounts you would like access to:
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-center">
                    {accounts ?
                        <ToggleButtonGroup
                            className="mb-2"
                            type="checkbox"
                            vertical
                        >
                            {accounts.map((acct, idx) => {
                                return (
                                    <ToggleButton
                                        id={"Acct" + idx}
                                        key={"Acct" + idx}
                                        type="checkbox"
                                        variant="light"
                                        checked={tempAccounts.includes(acct.id)}
                                        value={acct.id}
                                        onChange={(e) => { setTempAccounts(changeTempAccountsList(e.target.value, e.target.checked)); }}
                                    >
                                        {acct.legalName}
                                        </ToggleButton>
                                )
                            })}
                            </ToggleButtonGroup>
                        :<></>
                        }
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <Row>
                    <Col className="d-flex justify-content-center">
                        <div className="d-flex justify-content-center">
                            <HHIEButton 
                                id="accept-btn" 
                                onClick={() => { submitAccountsList() }}
                                title="Accept"
                            />
                        </div>
                    </Col>
                </Row>
            </Modal.Footer>
            <Modal.Footer className="d-flex justify-content-center">
                <br/>
                <Row>
                    <Col className="d-flex justify-content-center">
                    <div>
                        Don't think you should have access one or more of these accounts?
                    </div>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-contents-center">
                            <HHIEButton
                                id="alert-hhie-btn"
                                variant='warning'
                                onClick={() => { setAlertHHIE(true) }}
                                title="Alert the HHIE"
                            />
                    </Col>
                </Row>
            </Modal.Footer>
            </Modal>
            <Modal
                show={alertHHIE}
                size="md"
                centered
                backdrop="static"
                onHide={() => { setAlertHHIE(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Select accounts to send alert for:</Modal.Title>
                </Modal.Header>
                <br />
                <Modal.Body>
                    <div className="d-flex justify-content-center">
                    {accounts ?
                        <ToggleButtonGroup
                            className="mb-2"
                            type="checkbox"
                            vertical
                        >
                            {accounts.map((acct, idx) => {
                                return (
                                    <ToggleButton
                                        id={"AlertAcct" + idx}
                                        key={"Acct" + idx}
                                        type="checkbox"
                                        variant="light"
                                        checked={tempAlertAccounts.includes(acct.id)}
                                        value={acct.id}
                                        onChange={(e) => { setTempAlertAccounts(changeTempAlertAccountsList(e.target.value, e.target.checked)); }}
                                    >
                                        {acct.legalName}
                                    </ToggleButton>
                                )
                            })}
                        </ToggleButtonGroup>
                        : <></>
                        }
                        
                    </div>
                </Modal.Body>
                <br />
                <Modal.Footer className="d-flex justify-content-center">
                    <Row>
                        <Col className="d-flex justify-content-center">
                            <div className="d-flex justify-content-center">
                                <HHIEButton 
                                    id="send-alert-btn" 
                                    onClick={() => { submitAlertAccountsList() }} 
                                    variant='warning'
                                    title="Send Alert"
                                />
                            </div>
                        </Col>
                    </Row>
                    <br/><br/><br/><br/>
                </Modal.Footer>
            </Modal>
        </>
    );
}
